import { NgModule } from '@angular/core';
import { CommonModule, JsonPipe } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';

//import { PROJECT_STATES } from './project-display.states';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { UIRouterModule } from '@uirouter/angular';
import { ProjectDataService } from './data-access/project-data.service';
import { ProjectDisplayContainerComponent } from './feature/project-display-container/project-display-container.component';
import { ProjectHeaderComponent } from './ui/project-header/project-header.component';

// Equipment Section
import { BaseComponent, EquipmentAndCapacitiesContainerComponent } from './feature/equipment-and-capacities-container/equipment-and-capacities-container.component';
// , DynamicComponentFour, DynamicComponentOne, DynamicComponentSix, DynamicComponentThree, DynamicComponentTwentyTwo, DynamicComponentTwo, EquipmentAndCapacitiesContainerComponent } from './feature/equipment-and-capacities-container/equipment-and-capacities-container.component';
import { AssetCarbonCapture, PowerCapacity } from './ui/equipment/equipment.components';
import { PowerFuelTypes } from './ui/equipment/equipment.components';
import { WindTurbines } from './ui/equipment/equipment.components';
import { FieldTypes } from './ui/equipment/equipment.components';
import { LNGPlants } from './ui/equipment/equipment.components';
import { Pipelines } from './ui/equipment/equipment.components';
import { Storage } from './ui/equipment/equipment.components';
import { Terminals } from './ui/equipment/equipment.components';
import { ElectricalCables } from './ui/equipment/equipment.components';
import { Platforms } from './ui/equipment/equipment.components';
import { FloatingUnits } from './ui/equipment/equipment.components';
import { CCSTechnologyAndStorage } from './ui/equipment/equipment.components';
import { EmissionSystems } from './ui/equipment/equipment.components';
// import { Flowlines } from './ui/equipment/equipment.components';
// import { Risers } from './ui/equipment/equipment.components';
// import { SubseaTrees } from './ui/equipment/equipment.components';
// import { Umbilicals } from './ui/equipment/equipment.components';
import { TidalTurbines } from './ui/equipment/equipment.components';
import { Wells } from './ui/equipment/equipment.components';
import { Compressors } from './ui/equipment/equipment.components';
import { ProcessFacilities } from './ui/equipment/equipment.components';
import { Manifolds } from './ui/equipment/equipment.components';
import { GasProcessing } from './ui/equipment/equipment.components';
import { Solar } from './ui/equipment/equipment.components';
import { WaveDevices } from './ui/equipment/equipment.components';
import { Geothermal } from './ui/equipment/equipment.components';
import { DrillingFacilities } from './ui/equipment/equipment.components';
import { Vessels } from './ui/equipment/equipment.components';
import { AluminiumFacility } from './ui/equipment/equipment.components';
import { Plant } from './ui/equipment/equipment.components';
import { Surf } from './ui/equipment/equipment.components';
import { CapexPackages } from './ui/equipment/equipment.components';
import { HydrogenCapacity } from './ui/equipment/equipment.components';

import { ProjectLocationsComponent } from './ui/project-locations/project-locations.component';
import { OperatingCompaniesComponent } from './ui/operating-companies/operating-companies.component';

import { HighlightKeywordsPipe } from './utils/highlight-keywords.pipe';
import { HighlightService } from './utils/highlight.service';


import { ProjectNotesContainer } from './ui/project-notes/project-notes-container/project-notes-container';
import { ProjectNotesList } from './ui/project-notes/project-notes-list/project-notes-list';
import { ProjectNotesHeader } from './ui/project-notes/project-notes-header/project-notes-header';
import { NormalProjectNote } from './ui/project-notes/normal-project-note/normal-project-note';
import { AnalystProjectNote } from './ui/project-notes/analyst-project-note/analyst-project-note';
import { MemberProjectNote } from './ui/project-notes/member-project-note/member-project-note';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { ProjectNotesStoreService } from './data-access/project-notes-store-service';
import { ContractStagesContainerComponent } from './ui/contracts/contract-stages-container/contract-stages-container.component';
import { ContractStageComponent } from './ui/contracts/contract-stage/contract-stage.component';
import { ContractComponent } from './ui/contracts/contract/contract.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CompanyOfficesAndContactsComponent } from './ui/company-offices-and-contacts/company-offices-and-contacts.component';
import { DisplayContactComponent } from './ui/display-contact/display-contact.component';
import { DisplayOfficeAddressComponent } from './ui/display-office-address/display-office-address.component';
import { AssetContractors } from './ui/asset-contractors';
import { AssetOperators } from './ui/asset-operators';
import { AssetRelatedProjects } from './ui/asset-related-projects';
import { ProjectFidComponent } from './ui/project-fid/project-fid.component';
import { ProjectRelatedProjectsAndLinksComponent } from './ui/project-related-projects-and-links/project-related-projects-and-links.component';
import { FeedbackDialogComponent } from './ui/feedback-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { LogEventDirective } from './directives/log-event.directive';
import { ConfigService } from '../config/config.service';
import { PROJECT_DISPLAY_CONFIG } from '../config/project-display-config.token';
import { CreateMemberNoteDialogComponent } from './ui/project-notes/member-note-dialogs/create-member-note-dialog/create-member-note-dialog.component';
import { UpdateMemberNoteDialogComponent } from './ui/project-notes/member-note-dialogs/update-member-note-dialog/update-member-note-dialog.component';
import { DeleteMemberNoteDialogComponent } from './ui/project-notes/member-note-dialogs/delete-member-note-dialog/delete-member-note-dialog.component';
import { ProjectActionsComponent } from './ui/project-actions/project-actions.component';
import { CreateProjectWatchDialogComponent } from './ui/project-actions/create-project-watch-dialog/create-project-watch-dialog.component';
import { SingleProjectPdfReportDialogComponent } from './ui/project-actions/single-project-pdf-report-dialog/single-project-pdf-report-dialog.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';







@NgModule({
  declarations: [
    ProjectDisplayContainerComponent,
    ProjectHeaderComponent,
    EquipmentAndCapacitiesContainerComponent,
    ProjectLocationsComponent,
    OperatingCompaniesComponent,
    AssetOperators,

    ContractStagesContainerComponent,
    ContractStageComponent,
    ContractComponent,
    CompanyOfficesAndContactsComponent,
    DisplayContactComponent,
    DisplayOfficeAddressComponent,
    AssetContractors,
    AssetRelatedProjects,
    ProjectFidComponent,
    ProjectRelatedProjectsAndLinksComponent,

    ProjectNotesContainer,
    ProjectNotesHeader,
    ProjectNotesList,
    NormalProjectNote,
    AnalystProjectNote,
    MemberProjectNote,
    CreateMemberNoteDialogComponent,
    UpdateMemberNoteDialogComponent,
    DeleteMemberNoteDialogComponent,
    ProjectActionsComponent,
    CreateProjectWatchDialogComponent,
    SingleProjectPdfReportDialogComponent,

    HighlightKeywordsPipe,

    // Equipoment Section
    BaseComponent,
    // DynamicComponentOne,
    // DynamicComponentTwo,
    // DynamicComponentThree,
    // DynamicComponentFour,
    // DynamicComponentSix,
    // DynamicComponentTwentyTwo,

    PowerCapacity,
    PowerFuelTypes,
    WindTurbines,
    FieldTypes,
    LNGPlants,
    Pipelines,
    Storage,
    Terminals,
    ElectricalCables,

    Platforms,
    FloatingUnits,
    CCSTechnologyAndStorage,
    AssetCarbonCapture,
    EmissionSystems,
    // Flowlines,

    // Risers,
    // SubseaTrees,
    // Umbilicals,
    TidalTurbines,
    Wells,

    Compressors,
    ProcessFacilities,
    Manifolds,
    GasProcessing,
    Solar,

    WaveDevices,
    Geothermal,
    DrillingFacilities,
    Vessels,
    AluminiumFacility,

    Plant,
    Surf,
    CapexPackages,
    HydrogenCapacity,
    FeedbackDialogComponent,
    LogEventDirective
  ],
  imports: [
    CommonModule,

    FormsModule,
    // ReactiveFormsModule,
    FlexLayoutModule,
    MatCheckboxModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatExpansionModule,
    MatIconModule,
    MatDialogModule,
    MatMenuModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatSelectModule,

    JsonPipe
    //UIRouterModule.forChild({ states: PROJECT_STATES })
  ],
  providers: [
    ProjectDataService,
    ProjectNotesStoreService,
    provideHttpClient(withInterceptorsFromDi()),
    HighlightService,
    {
      provide: PROJECT_DISPLAY_CONFIG,
      useFactory: (configService: ConfigService) => configService.projectDisplay(),
      deps: [ConfigService]
    }
  ],
  exports: [
    ProjectDisplayContainerComponent
  ]
})
export class ProjectDisplayModule { }
